import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.css']
})
export class ErrorComponent implements OnInit {


  public message: any = '';
  public title: any = '';

  constructor(
    public dialogRef: MatDialogRef<ErrorComponent>, 
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.message = data.message;
    this.title = data.title;
  }

  ngOnInit(): void {
  }

  aceptar() {
    this.dialogRef.close();
  }
}
